"use strict";
import { spacing } from "ui/src/theme";
export const DEFAULT_BOTTOM_INSET = spacing.spacing20;
export var MobileDeviceHeight = /* @__PURE__ */ ((MobileDeviceHeight2) => {
  MobileDeviceHeight2[MobileDeviceHeight2["iPhoneSE"] = 667] = "iPhoneSE";
  MobileDeviceHeight2[MobileDeviceHeight2["iPhone12"] = 812] = "iPhone12";
  return MobileDeviceHeight2;
})(MobileDeviceHeight || {});
